import DepositData from "../../entities/DepositData";
import SalaryData from "../../entities/SalaryData";
import TransactionsData from "../../entities/TransactionsData";
import UserCmDoc from "../../entities/UserCMDoc";
import UserMasConfirm from "../../entities/UserMasConfirm";

export function filterByDate(
  docs: any,
  startDate?: string | Date | number,
  endDate?: string | Date | number
) {
  if (startDate && endDate && docs?.length) {
    return docs.filter(
      (doc: UserCmDoc) =>
        new Date(doc.DocDate) >= new Date(startDate) &&
        new Date(doc.DocDate) <= new Date(endDate)
    )
    .sort((a:any,b:any)=>{
      return   new Date(b.DocDate).valueOf() - new Date(a.DocDate).valueOf();
    });
  }
}

export function filterMasByDate(
  docs: any,
  startDate?: string | Date | number,
  endDate?: string | Date | number
) {
  if (startDate && endDate && docs?.length) {
    return docs.filter(
      (doc: UserMasConfirm) =>
        new Date(doc.dolvaliditydate) >= new Date(startDate) &&
        new Date(doc.dolvaliditydate) <= new Date(endDate)
    );
  }
}

export function filterDepositsByDate(
  deposits: any,
  startDate?: string | Date | number,
  endDate?: string | Date | number,
  fundCode?: number
) {
  if (startDate && endDate && deposits?.length) {
    if (fundCode) {
      return deposits.filter(
        (deposit: DepositData) =>
          new Date(deposit.depositDate.split("T")[0]) >= new Date(startDate) &&
          new Date(deposit.depositDate.split("T")[0]) <= new Date(endDate) &&
          deposit.fundCode === fundCode
      ).sort((a:any,b:any)=>{
        return   new Date(b.DocDate).valueOf() - new Date(a.DocDate).valueOf();
      });;
    }
    return deposits.filter(
      (deposit: DepositData) =>
        new Date(deposit.depositDate.split("T")[0]) >= new Date(startDate) &&
        new Date(deposit.depositDate.split("T")[0]) <= new Date(endDate)
    ).sort((a:any,b:any)=>{
      return   new Date(b.DocDate).valueOf() - new Date(a.DocDate).valueOf();
    });;
  }
}

export function filterTransactionsByDate(
  transactions: any,
  startDate?: string | Date | number,
  endDate?: string | Date | number,
  fundCode?: number
) {
  if (startDate && endDate && transactions?.length) {
    if (fundCode) {
      return transactions.filter(
        (transactions: TransactionsData) =>
          new Date(transactions.dateValue.split("T")[0]) >=
            new Date(startDate) &&
          new Date(transactions.dateValue.split("T")[0]) <= new Date(endDate) &&
          transactions.fundCode === fundCode
      );
    }
    return transactions.filter(
      (transactions: TransactionsData) =>
        new Date(transactions.dateValue.split("T")[0]) >= new Date(startDate) &&
        new Date(transactions.dateValue.split("T")[0]) <= new Date(endDate)
    );
  }
}

export function filterAscribedDepositsByDate(
  deposits: any,
  startDate?: string | Date | number,
  endDate?: string | Date | number,
  ascribed?: boolean,
  fundCode?: number
) {
  if (startDate && endDate && deposits?.length) {
    if (ascribed && fundCode) {
      return deposits.filter(
        (deposit: DepositData) =>
          new Date(deposit.depositDate.split("T")[0]) >= new Date(startDate) &&
          new Date(deposit.depositDate.split("T")[0]) <= new Date(endDate) &&
          deposit.fullyAscribed &&
          deposit.fundCode === fundCode
      );
    } else if (ascribed) {
      return deposits.filter(
        (deposit: DepositData) =>
          new Date(deposit.depositDate.split("T")[0]) >= new Date(startDate) &&
          new Date(deposit.depositDate.split("T")[0]) <= new Date(endDate) &&
          deposit.fullyAscribed
      );
    } else if (fundCode) {
      return deposits.filter(
        (deposit: DepositData) =>
          new Date(deposit.depositDate.split("T")[0]) >= new Date(startDate) &&
          new Date(deposit.depositDate.split("T")[0]) <= new Date(endDate) &&
          deposit.fundCode === fundCode &&
          !deposit.fullyAscribed
      );
    }

    return deposits.filter(
      (deposit: DepositData) =>
        new Date(deposit.depositDate.split("T")[0]) >= new Date(startDate) &&
        new Date(deposit.depositDate.split("T")[0]) <= new Date(endDate) &&
        !deposit.fullyAscribed
    );
  }
}

export function filterSalaryByDate(
  salaryData: any,
  startDate?: string | Date | number,
  endDate?: string | Date | number
) {
  if (startDate && endDate && salaryData?.length) {
    return salaryData.filter(
      (salary: SalaryData) =>
        new Date(salary.salaryDate.split("T")[0]) >= new Date(startDate) &&
        new Date(salary.salaryDate.split("T")[0]) <= new Date(endDate)
    );
  }
}
